var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgIconBikeBig = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91.656,
    height: 91.656,
    viewBox: "0 0 91.656 91.656",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(-678.15 -1976.15)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1016",
    "data-name": "Group 1016",
    transform: "translate(101 -5)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_98",
    "data-name": "Line 98",
    y2: 6,
    transform: "translate(622.978 1982)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_99",
    "data-name": "Line 99",
    x1: 6,
    transform: "translate(578 2026.978)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_97",
    "data-name": "Line 97",
    x1: 6,
    transform: "translate(661.496 2026.978)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_96",
    "data-name": "Line 96",
    y2: 6,
    transform: "translate(624.066 2065.5)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101",
    "data-name": "Group 101",
    transform: "translate(697.861 2001.246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_100",
    "data-name": "Group 100",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_17",
    "data-name": "Line 17",
    y1: 1.721,
    x2: 3.521,
    transform: "translate(47.531 25.866)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_18",
    "data-name": "Line 18",
    y1: 3.623,
    x2: 7.413,
    transform: "translate(40.118 27.587)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M702.634,585.074l-2,.331h-1.931",
    transform: "translate(-662.449 -553.875)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M717.017,588.442h0a1.484,1.484,0,0,0,.334-2.443l-1.745-1.54a2.772,2.772,0,0,0-1.851-.706h-5.471a6.908,6.908,0,0,0-5.932,3.369l-4.18,6.987h4.051",
    transform: "translate(-665.964 -562.578)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M713.5,584.371a8.111,8.111,0,1,1-14.794,5.667",
    transform: "translate(-662.448 -558.508)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M699.215,588.224a4.251,4.251,0,1,0,7.412-3.627",
    transform: "translate(-659.094 -557.012)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M712.978,596.645h1.252a2.085,2.085,0,0,0,2.086-2.086v-.243l-.167-.842L715.8,590.8a8.564,8.564,0,0,0-8.482-7.435h-8.573a2.1,2.1,0,0,0-1.768.979l-2.458,3.892-.326,1.123v5.2a2.092,2.092,0,0,0,2.094,2.086h16.9",
    transform: "translate(-692.173 -565.114)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_99",
    "data-name": "Group 99",
    transform: "translate(5.161 31.698)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M710.455,585.14a8.109,8.109,0,0,1-15.848,0",
    transform: "translate(-694.607 -585.14)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M702.391,585.14a3.756,3.756,0,0,1-7.2,0",
    transform: "translate(-690.76 -585.14)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M704.279,587.086v-1.563a1.009,1.009,0,0,0-.341-.728l-.971-.956a2.669,2.669,0,0,0-1.791-.592h-1.76v3.839",
    transform: "translate(-657.771 -565.911)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M702.979,586.865V583.1a.254.254,0,0,0-.228-.266h-7.814",
    transform: "translate(-687.272 -568.612)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M695.947,589.362l-1.866-5.592c-.114-.174-.243-.4-.068-.4h6.16",
    transform: "translate(-693.927 -565.114)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M701.679,590.362V582.5a.18.18,0,0,0-.174-.189h-7.4a.18.18,0,0,0-.174.189v7.867",
    transform: "translate(-693.886 -572.109)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M697.811,581.284",
    transform: "translate(-668.342 -578.841)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_19",
    "data-name": "Line 19",
    y1: 0.001,
    x2: 10.502,
    transform: "translate(21.705 31.53)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M710,598.3c-.948-5.227-2.087-10.325-3.118-15.8a1.825,1.825,0,0,0-1.752-1.532h-4.977a2.427,2.427,0,0,0-2.344,2.5h0a.686.686,0,0,0,.66.706h4.666a.629.629,0,0,1,.607.516l3.24,18.511",
    transform: "translate(-668.342 -580.962)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_995",
    "data-name": "Group 995",
    transform: "translate(679 1977)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_80",
    "data-name": "Ellipse 80",
    cx: 44.978,
    cy: 44.978,
    r: 44.978,
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#006d48",
    strokeMiterlimit: 10,
    strokeWidth: 1.7
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIconBikeBig, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/icon_bike_big.6695e2eb.svg";
export { ForwardRef as ReactComponent };